import { useMutation } from 'react-query';
import { queryClient } from '../../../../../../config/queryClient';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';
import { useIsPdf } from '../../../../hooks/useIsPdf';
import { useClientId } from '../../../../../_hooks/useClientId';

interface DeleteEstatePlanningDocumentParams {
  id: string;
  clientId: string;
}

const deleteEstatePlanningDocument = (params: DeleteEstatePlanningDocumentParams) =>
  authFetch(urlWithParams('/Consumer/EstatePlanning', params), {
    method: 'DELETE',
  });

export const useDeleteEstatePlanningDocumentMutation = () => {
  const fpId = useFpId();

  const isPdf = useIsPdf();

  const clientId = useClientId();

  return useMutation(deleteEstatePlanningDocument, {
    onSuccess: async () => {
      const queryKey = queryKeys.financialPlan(clientId, fpId, isPdf);

      await queryClient.invalidateQueries(queryKey);
    },
  });
};
